import { QueryClient } from '@tanstack/react-query'

/**
 * Singleton TanStack Query client for the Rails-side React islands mounted
 * from `app/javascript/entrypoints/react.ts`. Used by:
 *   - `entrypoints/react.ts` to install `QueryClientProvider` around every island
 *   - any call site that needs imperative cache access
 *     (`invalidateQueries`, `setQueryData`, `cancelQueries`)
 *
 * Mirrors the portal's `portal/app/lib/query-client.ts` so the two sides have
 * identical defaults.
 *
 * Defaults:
 *   - `retry: false` — surface errors immediately rather than masking them
 *     behind silent retries. The CSRF retry is handled at the interceptor
 *     layer; nothing else should auto-retry by default.
 *   - `refetchOnWindowFocus: false` — most islands don't need it; opt in per
 *     query where it matters.
 */
export const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})
